import {
  BuildingTypesEnum,
  ProjectStatusesEnum,
  PropertyTransactionTypesEnum,
} from "dash-common";
import { GetBrokerPropertiesLocationFilterInput } from "gql/generated.graphql";
import { Updater } from "use-immer";

export const DEFAULT_BOUND_DISTANCE = 0.5;
export const Z_INDEX_HOVER = 999;
export const Z_INDEX_SELECTED = 998;
export const Z_INDEX_CLUSTER = 997;
export const PIXEL_DISTANCE_FROM_MOUSE = 25; // Desired pixel distance from the mouse position
export const CARD_WIDTH = 300; // Fixed width of the card in pixels
export const CARD_HEIGHT = 380; // Fixed height of the card in pixels - approximation
export const DEFAULT_PROPERTIES_PER_PAGE = 3;

export type IdxEmbeddedSearchPageFilters = {
  searchText: string;
  marketAreaIds: string[];
  buildingTypes: BuildingTypesEnum[];
  projectStatus: ProjectStatusesEnum[];
  transactionType: PropertyTransactionTypesEnum[];
  priceRange: {
    min?: number | null;
    max?: number | null;
  };
  locationFilter: GetBrokerPropertiesLocationFilterInput;
};

export type SearchBarFiltersProps = {
  filters: IdxEmbeddedSearchPageFilters;
  mainColor: string;
  mainColorLight: string;
  textColor: string;
  isMobile?: boolean;
  setFilters: Updater<IdxEmbeddedSearchPageFilters>;
  goToFirstPage?: () => void;
};
